

export const WRONG_OLD_PASSWORD = "WRONG_OLD_PASSWORD";
export const PASSWORD_TOO_SHORT = "PASSWORD_TOO_SHORT";
export const ERROR_ALREADY_IN_APPROVAL_FLOW = "ERROR_ALREADY_IN_APPROVAL_FLOW";